import { z } from "zod";

import { validateEircode } from "utils/validators";

export const formSchema = z.object({
  consultationDate: z.string().min(1, { message: "Please provide consultation date." }),
  eircode: z
    .string()
    .min(1, { message: "Please provide eircode." })
    .refine(
      (val) => validateEircode(val).isValid,
      (val) => ({ message: validateEircode(val).error || "Invalid Eircode format" })
    ),
  ethnicityCode: z.string().optional(),
  contractDoctor: z
    .string({ required_error: "Please provide contract doctor." })
    .min(1, { message: "Please provide contract doctor." }),

  qrisk3: z.boolean().optional().default(false),
  qrisk3Year: z.string().optional(),
  hypertenstionStage1: z.boolean().optional().default(false),
  hypertenstionStage1Year: z.string().optional(),
  hypertenstionStage1NoTargetOrganDamage: z.boolean().optional().default(false),
  hypertenstionStage1NoTargetOrganDamageYear: z.string().optional(),
  hypertenstionStage2: z.boolean().optional().default(false),
  hypertenstionStage2Year: z.string().optional(),
  gestationalDiabetes: z.boolean().optional().default(false),
  gestationalDiabetesYear: z.string().optional(),
  preEclampsia: z.boolean().optional().default(false),
  preEclampsiaYear: z.string().optional(),
  preDiabetes: z.boolean().optional().default(false),
  preDiabetesYear: z.string().optional(),
  previousBNP: z.boolean().optional().default(false),
  previousBNPYear: z.string().optional(),
});
